<ui-section [title]="isNotNullish(title()) ? title() : ('PAGES.BUSINESS_INDICATORS.WIDGETS.ADVANCEMENT.TITLE' | translate)">
    <ui-section-content>
        @if (chartConfig.status() === 'resolved' && chartConfig.value()) {
            <highcharts-chart class="height-100" [options]="chartConfig.value()" [recreateOnUpdate]="true" />
        }

        <loading-and-error [resource]="chartConfig" />
    </ui-section-content>
</ui-section>
